<template>
    <div>
        <managers :showLabel="true" :value.sync="managers" />
        <departments :showLabel="true" :value.sync="departments" />
        <occupation-groups
            :showLabel="true"
            :value.sync="occupationGroups"
            :placeholder="$t('form.placeholder.select')"
        />
        <questionnaires :showLabel="true" :value.sync="questionnaires" />
    </div>
</template>

<script>
import {
    Managers,
    Departments,
    OccupationGroups,
    Questionnaires,
} from '@/views/components/fields'

export default {
    name: 'AdminFilter',
    components: {
        Managers,
        Departments,
        OccupationGroups,
        Questionnaires,
    },
    data() {
        return {
            departments: [],
            managers: [],
            occupationGroups: [],
            questionnaires: [],
            filter: {
                departments: null,
                managers: null,
                occupationGroups: null,
                questionnaires: null,
            },
        }
    },
    watch: {
        departments() {
            this.filter = {
                ...this.filter,
                departments: this.mapIdsArray(this.departments),
            }
            this.emitFilters()
        },
        managers() {
            this.filter = {
                ...this.filter,
                managers: this.mapIdsArray(this.managers),
            }
            this.emitFilters()
        },
        occupationGroups() {
            this.filter = {
                ...this.filter,
                occupationGroups: this.mapIdsArray(this.occupationGroups),
            }
            this.emitFilters()
        },
        questionnaires() {
            this.filter = {
                ...this.filter,
                questionnaires: this.mapIdsArray(this.questionnaires),
            }
            this.emitFilters()
        },
    },
    methods: {
        mapIdsArray(items) {
            return items.map(e => e.value)
        },
        emitFilters() {
            this.$emit('changed', this.filter)
        },
    },
}
</script>
